<template>
    <div>
        <el-form ref="form" class="create-form pt0 mt20" :rules="rules" :model="form">
            <el-form-item>
                <div v-if="type==2">
                    <label class="f20 f-wwb text-fff">
                        <span class="text-danger mr5">*</span>{{$lang('authorCenter.stories.contractPlace[12]')}} <span class="f-fwb">{{contractTypeDesc}}</span>. {{$lang('authorCenter.stories.contractPlace[13]')}} <router-link class="text-theme" :to="'/Create/'+form.bookId" style="text-decoration: underline">{{$lang('authorCenter.stories.contractPlace[14]')}}</router-link> {{$lang('authorCenter.stories.contractPlace[15]')}}
                    </label>
                </div>
                <div class="author-info-form pb0 f24 text-fff" v-if="type==1">User ID: {{form.id}}</div>
            </el-form-item>
            <el-form-item prop="name" :label="$lang('authorCenter.stories.contractLabel[0]')">
                <el-input :disabled="!allowEditForm" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('authorCenter.stories.contractLabel[1]')" prop="userName">
                <el-input :disabled="!allowEditForm" v-model="form.userName"></el-input>
            </el-form-item>
            <!--作者年龄 -->
            <el-form-item :label="$lang('buyOut.form[0]')" prop="age">
                <el-input :disabled="!allowEditForm" v-model="form.age"></el-input>
            </el-form-item>
            <!--作者性别 -->
            <el-form-item :label="$lang('buyOut.form[1]')" prop="gender">
                <el-radio-group :disabled="!allowEditForm" class="m-l-0 m-b-0" v-model="form.gender">
                    <el-radio :label="0">{{$lang('create.girl')}}</el-radio>
                    <el-radio :label="1">{{$lang('create.boy')}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <!--身份证件类型 -->
            <el-form-item :label="$lang('buyOut.form[2]')" prop="idCardType">
                <el-select
                        style="width: 100%;"
                        v-model="form.idCardType"
                        :disabled="!allowEditForm">
                    <el-option
                            v-for="i in idCardType"
                            :label="i.desc "
                            :value="i.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <!--身份证件ID -->
            <el-form-item :label="$lang('buyOut.form[3]')" prop="idCardNumber">
                <el-input :disabled="!allowEditForm" v-model="form.idCardNumber"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('authorCenter.stories.contractLabel[15]')" prop="postalCode">
                <el-input :disabled="!allowEditForm" v-model="form.postalCode"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('authorCenter.stories.contractLabel[2]')" prop="email">
                <el-input :disabled="!allowEditForm" v-model="form.email"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('authorCenter.stories.contractLabel[3]')" prop="address">
                <el-input :disabled="!allowEditForm" v-model="form.address"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('authorCenter.stories.contractLabel[4]')" prop="accountType">
                <el-select :disabled="!allowEditForm" v-model="form.accountType">
                    <el-option :value="1" :label="$lang('authorCenter.stories.contractLabel[14]')"></el-option>
<!--                    <el-option :value="2" :label="$lang('buyOut.form[4]')"></el-option>-->
                </el-select>
            </el-form-item>
            <!--银行类型为1-->
            <template v-if="form.accountType == 1">
                <el-form-item :label="$lang('authorCenter.stories.contractLabel[19]')" prop="moneyType">
                    <el-select :disabled="!allowEditForm" v-model="form.moneyType" placeholder="">
                       <el-option value="self" :label="$lang('authorCenter.stories.contractLabel[20]')"></el-option>
                       <el-option value="dollar" :label="$lang('authorCenter.stories.contractLabel[21]')"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="bank" :label="$lang('authorCenter.stories.contractLabel[5]')">
                    <el-input :disabled="!allowEditForm" v-model="form.bank"></el-input>
                </el-form-item>
                <el-form-item prop="bankAddress" :label="$lang('authorCenter.stories.contractLabel[16]')">
                    <el-input :disabled="!allowEditForm" v-model="form.bankAddress"></el-input>
                </el-form-item>
                <el-form-item prop="bankBranchCode" :label="$lang('authorCenter.stories.contractLabel[17]')">
                    <el-input :disabled="!allowEditForm" v-model="form.bankBranchCode"></el-input>
                </el-form-item>
                <el-form-item prop="bankPostalCode" :label="$lang('authorCenter.stories.contractLabel[18]')">
                    <el-input :disabled="!allowEditForm" v-model="form.bankPostalCode"></el-input>
                </el-form-item>
                <el-form-item :label="$lang('authorCenter.stories.contractLabel[23]')">
                    <el-input :disabled="!allowEditForm" v-model="form.bankRoutingNumber"></el-input>
                </el-form-item>
                <el-form-item prop="swift" :label="$lang('authorCenter.stories.contractLabel[6]')">
                    <el-input :disabled="!allowEditForm" v-model="form.swift"></el-input>
                </el-form-item>
            </template>
            <!--银行类型为2-->
            <!-- PayPal email-->
<!--            <el-form-item prop="payPalEmail" :label="$lang('buyOut.form[5]')">-->
<!--                <el-input :disabled="!allowEditForm"  v-model="form.payPalEmail"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item prop="account" :label="$lang('authorCenter.stories.contractLabel[7]')">
                <el-input :disabled="!allowEditForm"  v-model="form.account"></el-input>
            </el-form-item>
            <!-- 收款人姓名-->
            <el-form-item prop="payeeName" :label="$lang('buyOut.form[6]')">
                <el-input :disabled="!allowEditForm"  v-model="form.payeeName"></el-input>
            </el-form-item>
            <!-- IFSC Code-->
            <el-form-item prop="ifsc" :label="$lang('buyOut.form[7]')">
                <el-input :disabled="!allowEditForm"  v-model="form.ifsc"></el-input>
            </el-form-item>
            <!-- IBAN Number-->
            <el-form-item prop="iban" :label="$lang('buyOut.form[8]')">
                <el-input :disabled="!allowEditForm"  v-model="form.iban"></el-input>
            </el-form-item>
            <!--  MICR Code-->
            <el-form-item prop="micr" :label="$lang('buyOut.form[9]')">
                <el-input :disabled="!allowEditForm"  v-model="form.micr"></el-input>
            </el-form-item>
            <!-- Guardian's Full Name  -->
            <el-form-item v-if="form.age<18" prop="guardianName" :label="$lang('buyOut.form[10]')">
                <el-input :disabled="!allowEditForm"  v-model="form.guardianName"></el-input>
            </el-form-item>
            <!-- Guardian's Signature Image  -->
            <el-form-item v-if="form.age<18" prop="guardianSign" :label="$lang('buyOut.form[11]')">
                <div class="avatar-uploader">
                    <div class="avatar-uploader">
                        <div style="background: #fff" class="el-upload el-upload--text" @click="allowEditForm?signNature():''">
                            <img v-if="!form.guardianSign" src="@/assets/account/img-huzhao.jpg">
                            <img v-if="form.guardianSign" :src="form.guardianSignUrl">
                        </div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item prop="whatsapp" :label="$lang('authorCenter.stories.contractLabel[8]')">
                <el-input :disabled="!allowEditForm" v-model="form.whatsapp"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('authorCenter.stories.contractLabel[9]')" prop="idImg">
                <div class="avatar-uploader">
                    <div class="el-upload el-upload--text">
                        <img v-if="form.idImg == '' || !form.idImg" src="@/assets/account/img-huzhao.jpg">
                        <img v-else :src="form.idImgUrl">
                    </div>
                    <input v-if="allowEditForm" type="file" name="file" @change="uploadFun" class="el-upload-input" accept="image/png, image/jpeg, image/jpg">
                </div>
            </el-form-item>
            <!-- 身份证反面 -->
            <el-form-item :label="$lang('authorCenter.stories.contractLabel[22]')">
                <div class="avatar-uploader">
                    <div class="el-upload el-upload--text">
                        <img v-if="form.idBackImg == '' || !form.idBackImg" src="@/assets/account/img-huzhao.jpg">
                        <img v-else :src="form.idBackImgUrl">
                    </div>
                    <input v-if="allowEditForm" type="file" name="file" @change="uploadBackIng" class="el-upload-input" accept="image/png, image/jpeg, image/jpg">
                </div>
            </el-form-item>
            <el-form-item :label="$lang('authorCenter.stories.contractLabel[10]')" prop="countryCode">
                <el-select :disabled="!allowEditForm" style="width: 100%" filterable v-model="form.countryCode" @change="form.targetOrgCode = '';getTargetOrg()">
                    <el-option v-for="i in countries" :value="i.code" :label="i.name">{{i.name}}</el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="targetOrgList.length > 0" :label="$lang('authorCenter.stories.contractLabel[11]')" prop="targetOrgCode">
                <el-select :disabled="!allowEditForm" style="width: 100%" filterable v-model="form.targetOrgCode">
                    <el-option v-for="i in targetOrgList" :value="i.org" :label="i.orgName">{{i.orgName}}</el-option>
                    <el-option :value="-1" label="无">无</el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="mobile" :label="$lang('authorCenter.stories.contractLabel[12]')">
                <el-input :disabled="!allowEditForm" v-model="form.mobile"></el-input>
                <span class="f12 text-tips">{{$lang('authorCenter.stories.contractLabel[13]')}}</span>
            </el-form-item>

            <el-form-item style="margin-top: 50px;">
                <el-button v-if="type==1" class="f16" size="medium"  @click="saveInfoFun()">{{$lang('authorCenter.profile.SAVE')}}</el-button>
                <el-button v-if="type==2" class="f16 create-btn" size="medium" @click="submitapply()"> {{$lang('authorCenter.stories.confirm')}}</el-button>
                <el-popover
                        v-if="signStauts&&(signStauts.code == -1|| signStauts.code == -2|| signStauts.code == -3)"
                        placement="top"
                        title=""
                        width="280"
                        popper-class="contract-pop"
                        trigger="hover"
                        :content="signStauts.msg">
                    <i slot="reference" class="el-icon-warning text-danger ml0" style="font-size: 25px;"></i>
                </el-popover>
            </el-form-item>
        </el-form>
        <div class="dialog-con" v-if="isShowPop">
            <div class="dialog-con-bg" style="height:100%"></div>
            <div class="dialog-warp contract-warp" ref="addImage">
                <div class="huaban-con">
                    <div class="close fr mr20 mt20 f24 text-fff f-fwb" @click="closeFun"><i class="el-icon-circle-close"></i></div>
                    <vue-fabric-sketchpad :reviewFlag="signNatrueFlag" :canvas-width="500" :canvas-height="300" placement="top" @composeImgFun="composeImgFun" @reviewContractFun="reviewContractFun"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
    signcontractdownload,
    authorlistTargetOrg,
    parentSignSave,
    inspectsign,
    idCardSave,
    reqIdCardBackSave,
    changeNormalInfo,
    } from "apiurl/author";
    import {showLoading, hideLoading} from "@/utils/load";
    import { fileTransferBase64 } from '@/utils/index';
    export default {
        name: "writerInfo",
        props:{
            type:{
                type: Number,//1，个人中心，2签约
                default:1
            },
            allowEditForm: {
                type: Boolean,
                default:true
            },
            reviewFlag: {
                type: Boolean,
                default:true
            },
            countries:{
                type: Array,
                 default: () => { return [] }
            },
            idCardType:{
                type: Array,
                default: () => { return [] }
            },
            form:{
                type: Object,
                default:{}
            },
            contractTypeDesc:{
                type: String,
                default:''
            },
            signStauts:{
                type: Object,
                default:null
            }
        },
        data(){
            var validatePass = (rule, value, callback) => {
                 if (value === null) {
                    callback();
                    return;
                };
                const reg = /^[1-9]\d*$/;
                if (!reg.test(Number(value))) {
                    callback('Please enter a valid number');
                } else {
                    callback();
                };
            };
            return{
                rules: {
                    email: [
                        { required: true, message: this.$lang('authorCenter.stories.contractPlace[0]'), trigger: "blur" },
                        { type: 'email', message: this.$lang('authorCenter.stories.newChapterPlace[5]'), trigger: ['blur', 'change'] }
                    ],
                    bank: [{ required: true, message:this.$lang('authorCenter.stories.contractPlace[1]'), trigger: "blur" }],
                    address: [{ required: true, message: this.$lang('authorCenter.stories.contractPlace[2]'), trigger: "blur" }],
                    bankAddress: [{ required: true, message: this.$lang('authorCenter.stories.contractPlace[16]'), trigger: "blur" }],
                    postalCode: [{ required: true, message: this.$lang('authorCenter.stories.contractPlace[19]'), trigger: "blur" }],
                    bankBranchCode: [{ required: true, message: this.$lang('authorCenter.stories.contractPlace[17]'), trigger: "blur" }],
                    bankPostalCode: [{ required: true, message: this.$lang('authorCenter.stories.contractPlace[18]'), trigger: "blur" }],
                    swift: [{ required: true, message: this.$lang('authorCenter.stories.contractPlace[3]'), trigger: "blur" }],
                    name: [{ required: true, message: this.$lang('authorCenter.stories.contractPlace[4]'), trigger: "blur" }],
                    userName: [{ required: true, message: this.$lang('authorCenter.stories.contractPlace[5]'), trigger: "blur" }],
                    accountType: [{ required: true, message: this.$lang('authorCenter.stories.contractPlace[6]'), trigger: "blur" }],
                    moneyType: [{ required: true, message: this.$lang('authorCenter.stories.contractPlace[20]'), trigger: "blur" }],
                    whatsapp: [{ required: true, message: this.$lang('authorCenter.stories.contractPlace[7]'), trigger: "blur" }],
                    mobile: [{ required: true, message: this.$lang('authorCenter.stories.contractPlace[8]'), trigger: "blur" }],
                    idImg: [{ required: true, message: this.$lang('authorCenter.stories.contractPlace[9]'), trigger: "change" }],
                    account: [
                        { required: true, message: this.$lang('authorCenter.stories.contractPlace[10]'), trigger: "blur" },
                    ],
                    countryCode: [
                        { required: true, message: this.$lang('authorCenter.stories.contractPlace[11]'), trigger: "blur" }
                    ],
                    age: [
                        { required: true, message: this.$lang('buyOut.formRules[0]'), trigger: "blur" },
                        { validator: validatePass}
                    ],
                    gender: [
                        { required: true, message: this.$lang('buyOut.formRules[1]'), trigger: "blur" },
                    ],
                    idCardType: [
                        { required: true, message: this.$lang('buyOut.formRules[2]'), trigger: "blur" },
                    ],
                    idCardNumber: [
                        { required: true, message: this.$lang('buyOut.formRules[3]'), trigger: "blur" },
                    ],
                    payPalEmail: [
                        { required: true, message: this.$lang('buyOut.formRules[4]'), trigger: "blur" },
                    ],
                    payeeName: [
                        { required: true, message: this.$lang('buyOut.formRules[5]'), trigger: "blur" },
                    ],
                    ifsc: [
                        { required: true, message: this.$lang('buyOut.formRules[6]'), trigger: "blur" },
                    ],
                    iban: [
                        { required: true, message: this.$lang('buyOut.formRules[7]'), trigger: "blur" },
                    ],
                    micr: [
                        { required: true, message: this.$lang('buyOut.formRules[8]'), trigger: "blur" },
                    ],
                    guardianName: [
                        { required: true, message: this.$lang('buyOut.formRules[9]'), trigger: "blur" },
                    ],
                    guardianSign: [
                        { required: true, message: this.$lang('buyOut.formRules[10]'), trigger: "blur" },
                    ],
                },
                targetOrgList: [],
                /*合同*/
                isShowPop: false,
                isHuaban: false,
                signature: '',
                downimg: '',
                signNatrueFlag:1,//1家长，2作者
            }
        },
        mounted() {
            this.getTargetOrg()
        },
        methods:{
            uploadFun (e, code) {
                if (e.target.files.length == 0) {
                    this.$faild('custom','Please select the picture to upload')
                    return false
                }
                showLoading()
                let file = e.target.files[0];
                if(file.size<1024*1024*3){
                    fileTransferBase64(file).then(data=>{
                        idCardSave({imageData: data}).then(res=>{
                            console.log(res)
                            hideLoading()
                            this.form.idImg = res.data.idImg
                            this.form.idImgUrl = res.data.idImgUrl
                            this.$refs['form'].clearValidate(['idImg']);
                        })
                    })
                } else {
                    hideLoading();
                    this.$faild('custom', 'The image cannot exceed 3M');
                };
            },
            uploadBackIng (e, code) {
                if (e.target.files.length == 0) {
                    this.$faild('custom','Please select the picture to upload');
                    return false;
                };
                showLoading();
                let file = e.target.files[0];
                if (file.size < 1024 * 1024 * 3) {
                    fileTransferBase64(file).then(data => {
                        reqIdCardBackSave({imageData: data}).then(res => {
                            // console.log(res);
                            hideLoading();
                            this.form.idBackImg = res.data.idBackImg;
                            this.form.idBackImgUrl = res.data.idBackImgUrl;
                        });
                    });
                } else {
                    hideLoading();
                    this.$faild('custom', 'The image cannot exceed 3M');
                };
            },
            getTargetOrg () {
                if (this.form.countryCode) {
                    authorlistTargetOrg( {countryCode: this.form.countryCode}).then(res=>{
                        if (res.success) {
                            this.targetOrgList = res.data
                        }
                    })
                }
            },
            //家长签字
            signNature(){
                this.isShowPop = true
                this.isHuaban = true
                this.signNatrueFlag=1
                this.$emit('changePop', true)
            },
            composeImgFun (data) {
                //上传家长签字
                if(this.signNatrueFlag==1){
                    parentSignSave({imageData:data}).then(res=>{
                        console.log(res)
                        this.form.guardianSign=res.data.guardianSign
                        this.form.guardianSignUrl=res.data.guardianSignUrl
                        console.log(this.form.guardianSign)
                        this.closeFun()
                    })
                }else{
                    /*第三步：画板签名且上传合同*/
                    this.signature = data
                    this.form.bookId = this.$route.params.id
                    this.form.imageData = this.signature
                    showLoading()
                    inspectsign(this.form).then(res=>{
                        console.log(res)
                        if (res.success) {
                            hideLoading()
                            this.$success('custom', res.message)
                            this.isShowPop = false
                            this.$emit('changePop', false)
                            this.$emit('submitapply',1)
                        } else {
                            this.$faild('custom', res.message)
                        }
                    })
                }

            },
            // 关闭弹框
            closeFun () {
                this.isHuaban = false
                this.isShowPop = false
                this.$emit('changePop', false)
            },
            //签约提交
            submitapply() {
                if (this.form.accountType == 2) {
                    this.rules.bank[0].required = false
                    this.rules.swift[0].required = false
                    this.form.bank = ''
                    this.form.swift = ''
                } else {
                    this.rules.bank[0].required = true
                    this.rules.swift[0].required = true
                }
                this.$refs.form.validate((valid) =>{
                    if (valid) {
                        showLoading()
                        // if (this.isChange == 2) {
                        //     this.form.idImg = this.form.idImgUrl
                        // }
                        this.form.targetOrgCode = this.form.targetOrgCode == -1?'':this.form.targetOrgCode
                        this.form.bookId = this.$route.params.id
                        signcontractdownload(this.form).then(res=>{
                            hideLoading()
                            if (res.success) {
                                this.contractInfo =res.data
                                this.isShowPop = true
                                this.isHuaban = true
                                this.signNatrueFlag=2
                                // this.$emit('changePop', true)
                            };
                        })
                    }else{
                        if(this.type==2&&!this.allowEditForm){
                            this.$faild('custom','Please go to the personal center to complete the information before signing！')
                        }
                    }
                })
            },
            /* 查看合同*/
            reviewContractFun () {
                let newWindow = window.open('', '_blank');
                setTimeout(()=>{
                    newWindow.location = this.contractInfo
                })
            },
            //个人中心修改
            saveInfoFun () {
                if (this.form.accountType == '2') {
                    this.form.bank = ''
                    this.form.swift = ''
                    this.rules.swift[0].required = false
                    this.rules.bank[0].required = false
                } else {
                    this.rules.bank[0].required = true
                    this.rules.swift[0].required = true
                }
                this.$refs.form.validate(valid => {
                    if (valid) {
                        if (this.isChange == 2) {
                            this.form.idImg = this.form.idImgUrl
                            this.form.idBackImg = this.form.idBackImgUrl;
                        }
                        this.form.targetOrgCode = this.form.targetOrgCode == -1?'':this.form.targetOrgCode
                        changeNormalInfo(
                            this.qs.stringify(this.form)
                        )
                            .then(res => {
                                if (res.success) {
                                    this.$success('edit')
                                    // 调取父组件接口 获取更新后form
                                    this.$emit('saveInfoFun')
                                }
                            })
                            .catch(() => {});
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/styles/author.scss";
    .avatar-uploader{
        width: 210px;
        height: 160px;
        position: relative;
    }
    .avatar-uploader .el-upload {
        width: 210px;
        height: 160px;
        img{
            width: 210px;
            height: 160px;
        }
    }
    .avatar-uploader .el-upload-input{
        width: 210px;
        height: 160px;
    }
    .huaban-con{
        width: 100%;
        height: 100%;
        position: relative;
        /deep/.composeImg-btn{
            margin-right: 30px;
        }
        /deep/.board-box{
            left: 50%;
            transform: translateX(-50%);
            top: 50px;
        }
        .view-btn{
            text-decoration: underline;
            position: absolute;
            left: 80px;
            bottom: 24px;
            color: #48A2DF;
        }
    }
    @media (max-width:768px){
        .close{
            margin-right: 130px!important;
        }
        /*width:100%!important;*/
    }
</style>